import React from "react";
import { useTableBusinessUnitsHook } from "./table-business-units-hooks";

type TableBusinessUnitsContext = ReturnType<typeof useTableBusinessUnitsHook>;
export const TableBusinessUnitsContext =
  React.createContext<TableBusinessUnitsContext | null>(null);

export function useContextTableBusinessUnits() {
  const context = React.useContext(TableBusinessUnitsContext);

  if (!context) {
    throw new Error(
      "useContextTableBusinessUnits must be used within a TableBusinessUnitsProvider",
    );
  }

  return context;
}
